import React, { useEffect, useState } from 'react';
import MaskReal from 'services/formateRS';

//core components
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import useAuth from "hooks/useAuth"
import api from "assets/services/api";

//bootstrap imports
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

//material compenents
import AddAlert from "@material-ui/icons/AddAlert";



function ModalUpdateOrderHeader(props) {
    console.log(props)
    const [clients, setClients] = useState([]);
    const [clientId, setClientId] = useState(props.props.client.id_client);
    const [payments, setPayments] = useState([{ id: 0, description: "" }])
    const [payment, setPayment] = useState(props.props.payment);
    const { storageId, user } = useAuth();

    useEffect(() => {
        loadClients();
        loadPayments();
    }, []);

    async function handleEditOrder(e) {
        e.preventDefault();
        for (let i = 0; i < props.props.products.length; i++) {
            const upd = await api.patch('/order/payment/' + props.props.products[i].id, {
                payment_method: payment,
                id_client: clientId,
                id_admin: storageId
            });
            console.log(upd)
        };
        console.log("fora for")
        props.loadOrders();
        props.onHide();
    }
    async function loadClients() {
        const response = await api.get('/client/sell/' + storageId);
        setClients(response.data);
    }
    const loadPayments = async () => {
        const responsePayment = await api.get('/payment')
        setPayments(responsePayment.data)
    };
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Editar pedido
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleEditOrder}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} controlId="formGridClient">
                                <Form.Label>Cliente</Form.Label>
                                <Form.Control onChange={event => setClientId(event.target.value)} value={clientId} as="select" defaultValue="Choose...">
                                    {clients.map(client => (
                                        <option key={client.id} value={client.id}>{client.social_reason}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Form.Row>
                    </Form.Row>
                    <Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} controlId="formGridSellsman">
                                <Form.Label>Pagamento</Form.Label>
                                <Form.Control onChange={(event) => setPayment(event.target.value)} as="select" value={payment}>
                                    {payments.map(pay => (
                                        <option key={pay.id} value={pay.description}>{pay.description}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Form.Row>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Editar
                        </Button>
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalUpdateOrderHeader;